import React, { useState, useContext } from "react"
import { IconButton, Stack, Box, Tooltip } from "@mui/material"
// Icons
import { MdDelete } from "react-icons/md"
import { TbEdit } from "react-icons/tb"

// Srcs
import "../../Style/actionstyle.scss"
import Delete from "../Include/Delete"
import { DELETE_MATERIAL } from "../../Schema/Material"
import { AuthContext } from "../../Context/AuthContext"
import { useMutation } from "@apollo/client"
import MaterialForm from "./MaterialForm"

export default function MaterialAction({ editData, setRefetch }) {

     // Modal update
     const [openEdit, setOpenEdit] = useState(false)
     const handleOpenEdit = () => setOpenEdit(true)
     const handleCloseEdit = () => setOpenEdit(false)

     // Modal delete
     const [openDel, setOpenDel] = useState(false)
     const handleOpenDel = () => setOpenDel(true)
     const handleCloseDel = () => setOpenDel(false)

     const [loading, setLoading] = useState(false)
     const { setAlert } = useContext(AuthContext)

     const [deleteMaterial] = useMutation(DELETE_MATERIAL, {
          onCompleted: ({ deleteMaterial }) => {
               setLoading(false)
               if (deleteMaterial?.status === true) {
                    setAlert(true, "success", deleteMaterial?.message)
                    handleCloseDel()
                    setRefetch()
               } else {
                    setAlert(true, "error", deleteMaterial?.message)
               }
          },
          onError: (error) => {
               setLoading(false)
               setAlert(true, "error", error?.message)
          }
     })

     const handleDelete = () => {
          setLoading(true)
          deleteMaterial({
               variables: {
                    id: editData?._id
               }
          })
     }

     return (
          <div>
               <Stack direction="row" justifyContent="right">
                    <Tooltip title="កែប្រែ" placement="top">
                         <IconButton onClick={handleOpenEdit} >
                              <Box className="update-container">
                                   <TbEdit className="update-icon" />
                              </Box>
                         </IconButton>
                    </Tooltip>
                    <Tooltip title="លុប" placement="top">
                         <IconButton onClick={handleOpenDel}>
                              <Box className="delete-container">
                                   <MdDelete className="delete-icon" />
                              </Box>
                         </IconButton>
                    </Tooltip>
               </Stack>

               <MaterialForm
                    open={openEdit}
                    handleClose={handleCloseEdit}
                    editData={editData}
                    setRefetch={setRefetch}
                    dialogTitle="Update"
               />

               <Delete
                    open={openDel}
                    handleClose={handleCloseDel}
                    title={"Material"}
                    loading={loading}
                    handleDelete={handleDelete}
               />
          </div>
     )
}
